// This import loads the firebase namespace along with all its type information.
import CuratedSeriesList from './curated-series-list-model'

export async function load_curatedSeriesLists(): Promise<CuratedSeriesList[]> {
  throw 'Not implemented'
}

export async function delete_curatedSeriesList(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_curatedSeriesList(): Promise<CuratedSeriesList> {
  throw 'Not implemented'
}
